module.exports = __webpack_public_path__ + "static/media/checked.647e41a6.svg";